import angular from "angular";
import { vsName as reportingModuleName } from "../../reporting";
import {
  contractDetailsTabsComponentOptions,
  ContractDetailTabsProvider,
  vsName as contractDetailsTabsComponentOptionsName,
  vsServiceName as contractDetailTabsServiceName,
} from "./components/views/contract/detail/tabs";
import { contractDetailTabsConfig } from "./components/views/contract/detail/tabs/contractDetailTabsConfig";

export const vsModuleName = "SlotTrak.Contract.Shared";

angular
  .module(vsModuleName, [reportingModuleName])
  .provider(contractDetailTabsServiceName, ContractDetailTabsProvider)
  .component(
    contractDetailsTabsComponentOptionsName,
    contractDetailsTabsComponentOptions
  )
  .config(contractDetailTabsConfig);
